import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useUser } from "./UserContext";
import "./css/SubscriptionSuccess.css";

function SubscriptionSuccess() {
  const { refreshUserPlan, userPlan } = useUser();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get("plan");

  useEffect(() => {
    refreshUserPlan();
  }, []);

  return (
    <div className="subscription-success-page">
      <div className="subscription-success-card">
        <h1>Subscription Activated 🎉</h1>
        <p>
          Your plan is now active:
          <strong> {plan || userPlan}</strong>
        </p>

        <Link to="/beatmaker" className="success-action-btn">
          Go to BeatMaker
        </Link>

        <Link to="/plans" className="success-secondary-btn">
          View Plans
        </Link>
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
